import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import styles from "./checkbox.css";
export default function Checkbox(_ref) {
  var elementID = _ref.elementID,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      className = _ref.className;

  var _useState = useState(Boolean(defaultValue)),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  function onClick() {
    setIsChecked(!isChecked);
  }

  useEffect(function () {
    var checkboxElement = document.getElementById(elementID);

    if (checkboxElement) {
      checkboxElement.setAttribute("checked", isChecked.toString());

      if (onChange) {
        onChange();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isChecked]);
  return React.createElement("div", {
    id: elementID,
    className: classnames(className, styles.checkboxContainer),
    onClick: onClick
  }, React.createElement("input", {
    type: "checkbox"
  }), isChecked ? React.createElement(SVGIcon, {
    name: "round-checkbox-checked",
    className: styles.checkboxSVG
  }) : React.createElement(SVGIcon, {
    name: "round-checkbox",
    className: styles.checkboxSVG
  }));
}